<h1 mat-dialog-title>Creación de Activo</h1>
<mat-dialog-content class="add-active">
  <mat-form-field>
    <input matInput [disabled]="true" placeholder="Latitud" value="{{data.lat}}"> 
  </mat-form-field>
  <mat-form-field>
    <input matInput [disabled]="true" placeholder="Longitud" value="{{data.lng}}">
  </mat-form-field>

  <mat-form-field *ngFor="let field of fields; let i=index">
    <input matInput [required]="field.formulario_campo_requerido" *ngIf="field.type!='date'&& field.type!='combo'" [disabled]="false" type="{{field.type}}" [(ngModel)]="valuesCampo[i]" placeholder="{{field.formulario_campo_nombre}}" />
    <input matInput [required]="field.formulario_campo_requerido" *ngIf="field.type=='date'" disabled [matDatepicker]="picker" [(ngModel)]="valuesCampo[i]" placeholder="{{field.formulario_campo_nombre}}" />
    <mat-label *ngIf="field.type =='combo'">{{field.formulario_campo_nombre}}</mat-label>
    <mat-select [required]="field.formulario_campo_requerido" [(ngModel)]="valuesCampo[i]" *ngIf="field.type=='combo'">
      <mat-option *ngFor="let option of field.options" value="{{option}}">{{option}}</mat-option>
    </mat-select>
    <!-- <input matInput required  [disabled]="false" type="{{field.type}}" [(ngModel)]="valuesCampo[i]" placeholder="{{field.formulario_campo_nombre}}" /> -->
    <mat-datepicker-toggle matSuffix *ngIf="field.type=='date'" [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker disabled="false"></mat-datepicker>
  </mat-form-field>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button type="submit" (click)="createActive()">Crear</button>
  <button mat-raised-button (click)="closeMe()">Cancelar</button>
</mat-dialog-actions>
